module.exports = __webpack_public_path__ + "img/avatar2.cf997aa0.png";